import { render, staticRenderFns } from "./ProcessVersionList.vue?vue&type=template&id=5dd5c5dc&scoped=true&"
import script from "./ProcessVersionList.vue?vue&type=script&lang=js&"
export * from "./ProcessVersionList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5dd5c5dc",
  null
  
)

export default component.exports